<template>
    <div class="container mt-5">
      <div class="card bg-danger text-white text-center">
        <div class="card-body">
          <h3 class="card-title" style="width: 100%;font-size: 30px;font-weight: 500;margin-bottom: 5px;">Akses Ditolak</h3>
          <p class="card-text mt-2" style="font-size:16px">Maaf, Anda tidak memiliki izin untuk mengakses halaman ini.</p>
          <router-link to="/dashboard" class="btn btn-light mt-2">Kembali ke Dashboard</router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "NotAllowed"
  };
  </script>
  